module.exports = __webpack_public_path__ + "img/purple.96ef6865.png";